<template>
    <div class="quote-details">

        <div class="toggle quote-details--toggle" v-b-toggle="'quote-detail-content'" v-html="chevron_down_toggler"></div>

        <div class="quote-details--heading">
            <div class="quote-details--title">
                <b-form-group label="Nome proposta" label-for="quote-details-title">
                    <b-form-input
                        size="sm"
                        id="quote-details-title"
                        v-model="title"
                        placeholder="titolo proposta"
                        required
                        @input="update_quote_details"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="quote-details--date">
                <label>Inizio pubblicazione</label>
                <date-time-picker
                    :header="false"
                    :smart_inputs="true"                
                    :day="publish_from"
                    :toggle_fields="true"
                    :context="{
                        for: 'quote_publish_from',
                    }"
                    @updated="(value) => refresh_date({
                            day: value.day,
                            //hour: value.hour,
                            context: value.context
                        })"
                />                
            </div>
            <div class="quote-details--date">
                <label>Acquistabile fino al</label>
                <date-time-picker
                    :header="false"
                    :smart_inputs="true"
                    :day="parsed_bookable_before.day"
                    :hour="parsed_bookable_before.hour || '14'"
                    :toggle_fields="true"
                    :context="{
                        for: 'quote_bookable_before',
                    }"
                    @updated="(value) => refresh_date({
                            day: value.day,
                            hour: value.hour,
                            context: value.context
                        })"
                />                
            </div>
            <div class="quote-details--date">
                <label>Fine pubblicazione</label>
                <date-time-picker
                    :header="false"
                    :smart_inputs="true"
                    :day="publish_to"
                    :toggle_fields="true"
                    :context="{
                        for: 'quote_publish_to',
                    }"
                    @updated="(value) => refresh_date({
                        day: value.day,
                        hour: value.hour,
                        context: value.context
                    })"
                />                
            </div>
            <div class="quote-details--occupancy">
                <!--<label>Pax</label>-->
                <occupancy 
                    @updated="(occupancy) => {
                        this.occupancy = occupancy
                        this.update_quote_details()
                    }"
                    :max_adults="/*config.guiSettings.searchMaxAdults*/100"
                    :max_children="/*config.guiSettings.searchMaxChildren*/100"
                    :default_adults="occupancy.adults ? occupancy.adults : 1"
                    :default_children="occupancy.children ? occupancy.children : []"
                />
            </div>
            <div class="quote-details--content">
                <b-collapse class="service--collapse" :id="'quote-detail-content'" accordion="quote-accordion">
                    <b-row>
                        <b-col>
                            <tiny-mce
                                :preview_mode="true"
                                :height="400"
                                :block_title="'Descrizione della soluzione'"
                                :initial_value="this.description"
                                @input="(value) => {
                                    this.description = value
                                    this.update_quote_details()
                                }"
                            />
                            <tiny-mce
                                :preview_mode="true"
                                :height="400"
                                :block_title="'Dal tuo consulente'"
                                :initial_value="this.agent_notes"
                                @input="(value) => {
                                    this.agent_notes = value
                                    this.update_quote_details()
                                }"
                            />
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <request-messages v-if="request_id" :request_id="request_id" :expanded="true" />
                        </b-col>
                    </b-row>
                </b-collapse>
            </div>
        </div>
    </div>    
</template>

<script>
    import Occupancy from '@/components/blocks/occupancy'
    import DateTimePicker from '@/components/blocks/date-time-picker'
    import { parse_flight_offers_date } from '@/utilities'
    import { chevron_down_toggler } from '@/components/svg/common'
    import TinyMce from "@/components/blocks/tiny-mce"
    import RequestMessages from '@/components/blocks/request-messages'

    export default {
        name: 'quote-details',
        components: {
            'occupancy': Occupancy,
            'date-time-picker': DateTimePicker,
            'tiny-mce': TinyMce,
            'request-messages': RequestMessages,
        },
        props:
        {
            //service_index: Number,
            details: {
                type: Object,
                default: () => {}
            },
            request_id: {
                type: String,
                default: '',
            }
        },
        created() {
            this.chevron_down_toggler = chevron_down_toggler
        },
        data()
        {
            let parsed_bookable_before = {}
            if(this.details && this.details.bookable_before){
                parsed_bookable_before = parse_flight_offers_date(this.details.bookable_before)
            }else{
                parsed_bookable_before = {
                day: this.today(),
                hour: '14:00',
                }
            }

            let bookable_before = parsed_bookable_before.day + 'T' + parsed_bookable_before.hour

            return {
                title: (this.details && this.details.title)? this.details.title : '',
                publish_from: (this.details && this.details.publish_from)? this.details.publish_from : this.today(),
                publish_to: (this.details && this.details.publish_to)? this.details.publish_to : this.today(),
                parsed_bookable_before: parsed_bookable_before,
                bookable_before: bookable_before,
                occupancy: ((this.details && this.details.occupancy) ? this.details.occupancy : {}),
                agent_notes: ((this.details && this.details.agent_notes) ? this.details.agent_notes : ''),
                description: ((this.details && this.details.description) ? this.details.description : ''),
            }
        },
        methods:
        {
            today(){
              return (new Date()).getFullYear() + '-' + ((new Date()).getMonth()+1) + '-' + (new Date()).getDate()
            },

            update_quote_details()
            {
                this.$store.commit('set_quote_details', {
                    title: this.title,
                    publish_from: this.publish_from,
                    publish_to: this.publish_to,
                    bookable_before: this.bookable_before,
                    occupancy: this.occupancy,
                    agent_notes: this.agent_notes,
                    description: this.description,
                })
            },
            refresh_date(value)
            {
                if(value.context.for == 'quote_publish_from') this.publish_from = value.day
                if(value.context.for == 'quote_publish_to') this.publish_to = value.day
                if(value.context.for == 'quote_bookable_before') this.bookable_before = value.day + 'T' + value.hour
                this.update_quote_details()
            }
        }
    }
</script>

<style lang="scss">
    .quote-details
    {
        @include subpanel;
        margin-bottom:1rem;
        display:flex;
        flex-wrap: wrap;
        
        &--toggle
        {
            //padding-right: $grid-gutter-width/2;
        }

        &--heading
        {
            flex:1;
            display: flex;
            flex-wrap: wrap;
            &>*
            {
                padding:0 0.5rem;
            }
        }

        &--content
        {
            width:100%;
        }

        &--title
        {
            flex:16.6%;
        }

        &--date
        {
            flex:16.6%;
        }

        &--occupancy
        {
            flex:33.6%;
        }

        &--column
        {
            width:100%;
            @include media-breakpoint-up(md)
            {
                width:20%;
            }
        }

        .form-group
        {
            margin-bottom:0;
        }
        
        .date-time-picker--smart-inputs
        {
            margin-bottom:0;
            &--text
            {
                display: none;
            }
        }
    }
</style>